"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var react_1 = __importStar(require("react"));
var react_2 = require("react");
var react_hook_form_1 = require("react-hook-form");
var react_i18next_1 = require("react-i18next");
var CurrencyUtils_1 = require("../../../../utils/CurrencyUtils");
var ExchangerUtils_1 = require("../../../../utils/ExchangerUtils");
var OrderServiceContext_1 = require("../OrderServiceContext");
var FormPaymentView = function (props) {
    var register = (0, react_hook_form_1.useFormContext)().register;
    var _a = (0, react_i18next_1.useTranslation)(), t = _a.t, i18n = _a.i18n;
    var _b = (0, OrderServiceContext_1.useOrderServiceContext)(), payment = _b.payment, exchanger = _b.exchanger, orderService = _b.orderService, setPayment = _b.setPayment, defaultCurrency = _b.defaultCurrency;
    var _c = (0, react_1.useState)(), commission = _c[0], setCommission = _c[1];
    var _d = (0, react_1.useState)([]), paymentList = _d[0], setPaymentList = _d[1];
    (0, react_1.useEffect)(function () {
        axios_1.default.get("/app/payment")
            .then(function (response) {
            setPaymentList(response.data);
        });
    }, []);
    function handleChangePayment(e) {
        var item = paymentList.find(function (x) { return x.id === parseInt(e.target.value); });
        setPayment(item);
    }
    (0, react_1.useEffect)(function () {
        if (orderService !== undefined && payment !== undefined) {
            var _commision = ((orderService.pay_amount * payment.commission) / 100);
            if (exchanger && payment) {
                var value = ExchangerUtils_1.ExchangerUtils.conver(exchanger, payment.currency_code);
                if (value) {
                    _commision = _commision / value;
                }
                else {
                    // @TODO error notification
                }
            }
            setCommission(_commision);
        }
        else {
            setCommission(undefined);
        }
    }, [payment, orderService, exchanger]);
    return (react_1.default.createElement(react_2.Fragment, null,
        react_1.default.createElement("div", { className: "__item" },
            react_1.default.createElement("span", { className: "__caption" }, t("service.view.order.payment.caption")),
            react_1.default.createElement("select", __assign({}, register("payment"), { onChange: handleChangePayment }),
                react_1.default.createElement("option", null, t("service.view.order.payment.select")),
                paymentList.map(function (item, index) {
                    return react_1.default.createElement("option", { key: index, value: item.id }, item.name);
                })),
            payment &&
                react_1.default.createElement("span", { className: "__bottom-caption" },
                    react_1.default.createElement("span", null, t("service.view.order.payment.commision")),
                    react_1.default.createElement("span", { className: "color-success" },
                        " ",
                        commission && commission.toFixed(2),
                        " ",
                        CurrencyUtils_1.CurrencyUtils.symbol(payment ? payment.currency_code : defaultCurrency))))));
};
exports.default = FormPaymentView;
